module.exports = "https://la-static.vkplay.ru/promo/newstart/img/warlord.58134853.png";